import { prop } from 'commons/util/object.js';
import { LANGUAGE_FILES, LANGUAGES } from '@/constants/language.js';

const REQUIRES_INTL = !window.Intl;

const loadWithIntl = (intlLoader, baseLoader) => Promise.all([
    baseLoader(),
    REQUIRES_INTL ? intlLoader() : Promise.resolve(),
]).then(([ baseLang ]) => baseLang);

const loaderMaker = (language) => ({
    [LANGUAGE_FILES.BASE]: () => loadWithIntl(
        () => import(/* webpackChunkName: "languages/[request]" */ `./intl/${language}`),
        () => import(/* webpackChunkName: "languages/[request]" */ `./${language}/base.json`),
    ),
    [LANGUAGE_FILES.MODERATION]: () => import(/* webpackChunkName: "languages/[request]" */ `./${language}/moderation.json`),
    [LANGUAGE_FILES.ANALYTICS]: () => import(/* webpackChunkName: "languages/[request]" */ `./${language}/analytics.json`),
});

const EN_LOADERS = loaderMaker('en-us');

const LOADERS = {
    [LANGUAGES.EN_EN]: EN_LOADERS,
};

export const loadIntl = () => {
    if (REQUIRES_INTL) {
        return import(/* webpackChunkName: "polyfills" */'intl');
    }
    return Promise.resolve();
};

export const getLoadersForLangAndFile = (lang = LANGUAGES.DEFAULT, file = LANGUAGE_FILES.BASE) => prop([ lang, file ], LOADERS);
